function updateButtonPrice() {
  const rechargeWidget = document.querySelector('recharge-subscription-widget');

  if (!rechargeWidget || !rechargeWidget.shadowRoot) return;

  const shadow = rechargeWidget.shadowRoot;
  const selectedOption = shadow.querySelector('.rc-purchase-option[part*="rc-purchase-option__selected"]');
  const priceEl = selectedOption.querySelector('.rc-purchase-option__prices .rc-price:last-child');
  const selectedPrice = [...priceEl.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent.trim()).find(text => text);

  const submitBtn = document.querySelector('product-form form button.product-form__submit');

  if (selectedPrice && submitBtn) {
    // const price = selectedPrice.textContent.trim();
    const price = selectedPrice;
    // console.log('ppp',price)
    submitBtn.querySelector('.price__regular .price-item--regular') ? submitBtn.querySelector('.price__regular .price-item--regular').textContent = price : submitBtn.innerHTML = `Add to cart • ${price}`;
  }
}

function initRechargeListener() {
  const rechargeWidget = document.querySelector('recharge-subscription-widget');

  if (!rechargeWidget?.shadowRoot) {
    setTimeout(initRechargeListener, 500);
    return;
  }

  const shadow = rechargeWidget.shadowRoot;

  const observer = new MutationObserver(() => {
  const radios = shadow.querySelectorAll('input[type="radio"]');

    if (radios.length) {
      console.log('Found radios', radios);


    // Initial price update on load
    updateButtonPrice();

      shadow.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) {
          console.log('Radio changed');
          updateButtonPrice();
        }
      });

      observer.disconnect();
    }
  });

  observer.observe(shadow, {
    childList: true,
    subtree: true
  });
}

initRechargeListener();
